
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import IntegrationDemo from '../integrations/IntegrationDemo';
import featureFlags from '@/lib/featureFlags';

const DemoSection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (featureFlags.enableSignup) {
      navigate('/onboarding');
    } else {
      // Scroll to whitelist section
      const whitelistElement = document.getElementById('whitelist-section');
      if (whitelistElement) {
        whitelistElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section id="demo-section" className="py-16 bg-gradient-to-b from-indigo-50/50 to-purple-50/50 dark:from-indigo-950/20 dark:to-purple-950/10">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">See VirtuStaff.ai in Action</h2>
          <p className="text-muted-foreground">
            Try our interactive demo to experience how your VirtuStaff team can help with tasks across different business functions. 
            Type a question or try one of the suggested prompts below!
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="bg-card rounded-lg shadow-md overflow-hidden border">
            {/* Slack Header */}
            <div className="bg-[#350d36] text-white p-3 flex items-center gap-2">
              <div className="h-3 w-3 rounded-full bg-red-500 mr-1"></div>
              <div className="h-3 w-3 rounded-full bg-yellow-500 mr-1"></div>
              <div className="h-3 w-3 rounded-full bg-green-500 mr-1"></div>
              <span className="text-sm font-medium ml-2">Slack - VirtuStaff Demo</span>
            </div>
            
            {/* Slack Interface */}
            <IntegrationDemo />
          </div>
          
          <div className="mt-8 text-center">
            <p className="text-sm text-muted-foreground mb-4">
              VirtuStaff.ai integrates seamlessly with your team's existing communication tools
            </p>
            <Button 
              onClick={handleGetStarted}
              className="bg-indigo-600 hover:bg-indigo-700 text-white"
            >
              {featureFlags.enableSignup ? 'Try it Yourself' : 'Join Whitelist'} <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;
